import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.ZONE_DISCOUNT_CREATE_SUCCESS, data: data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.ZONE_DISCOUNT_CREATE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 201) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const zoneDiscountCreate = (data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.ZONE_DISCOUNT_CREATE_REQUEST });

    axios
      .post('/polygon-discount', data)
      .then((response) => {
        handleResponse(dispatch, response);
      })
      .catch((response) => {
        onFailed(dispatch, response.response.data);
      });
  };
};
